import {
    useEffect,
    type FC
} from "react";
import {
    View
} from "react-native";
import type IPopoverAnchorProps from "./type";
import {
    usePopoverContext
} from "../../context";

const PopoverAnchor: FC<IPopoverAnchorProps> = ({
    children,
    style
}) => {
    const context = usePopoverContext({
        part: "Anchor"
    });

    const setIsAnchored = context?.setIsAnchored;

    useEffect(() => {
        if(!setIsAnchored) {
            return;
        }

        setIsAnchored(true);

        return () => {
            setIsAnchored(false);
        };
    }, [
        setIsAnchored
    ]);

    if(!context) {
        return null;
    }

    return <View
        ref={context.anchorRef}
        collapsable={false}
        style={style}
    >
        {children}
    </View>;
};
export default PopoverAnchor;
